var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 4.26829H14.4C14.4 2.92126 13.3255 1.82927 12 1.82927C10.6745 1.82927 9.6 2.92126 9.6 4.26829ZM7.8 4.26829C7.8 1.91098 9.6804 0 12 0C14.3196 0 16.2 1.91098 16.2 4.26829H23.1C23.597 4.26829 24 4.67779 24 5.18293C24 5.68806 23.597 6.09756 23.1 6.09756H21.5171L20.1107 20.8673C19.8875 23.2115 17.949 25 15.6316 25H8.36843C6.05105 25 4.11258 23.2115 3.88936 20.8673L2.4829 6.09756H0.9C0.402948 6.09756 0 5.68806 0 5.18293C0 4.67779 0.402948 4.26829 0.9 4.26829H7.8ZM10.2 10.061C10.2 9.55584 9.79704 9.14634 9.3 9.14634C8.80295 9.14634 8.4 9.55584 8.4 10.061V19.2073C8.4 19.7124 8.80295 20.122 9.3 20.122C9.79704 20.122 10.2 19.7124 10.2 19.2073V10.061ZM14.7 9.14634C15.197 9.14634 15.6 9.55584 15.6 10.061V19.2073C15.6 19.7124 15.197 20.122 14.7 20.122C14.203 20.122 13.8 19.7124 13.8 19.2073V10.061C13.8 9.55584 14.203 9.14634 14.7 9.14634ZM5.68099 20.6911C5.81492 22.0976 6.978 23.1707 8.36843 23.1707H15.6316C17.022 23.1707 18.185 22.0976 18.319 20.6911L19.7087 6.09756H4.2913L5.68099 20.6911Z",
    fill: "#AFDDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.ee7618a6b248c99867dabd1fe07cce2f.svg";
export { ForwardRef as ReactComponent };